export const getTestResultByVariable = (results = [], variable = "", coreDataId = "") => results.find((resultObj) => String(resultObj?.backendVariable) === String(variable) && String(resultObj?.coreDataId) === String(coreDataId)) || {};

export const formatColor = (value) => {
    return value?.toLowerCase() === "na" ? "#fff" : value;
};

export const getColorsAndLetter = (testAnalysisType = "", productCodeTitle = "", resultObj = {}) => {
    const keys = testAnalysisType.split(",");
    const colorObj = resultObj?.colors?.find((obj) => obj.productCode === productCodeTitle) || {};
    const datum = {
        color: {},
        label: {},
    };

    keys.forEach((ele, i) => {
        if (i === 0) {
            datum["color"][ele] = formatColor(colorObj["common"]);
        } else if (i === 1) {
            datum["color"][ele] = formatColor(colorObj["ordinary"]);
        }
        datum["label"] = colorObj["label"];
    });
    return datum;
};

export const getColorsAndLetterForIctAgreement = (testAnalysisType = "", productCodeTitle = "", resultObj = {}) => {
    if (testAnalysisType) {
        const keys = testAnalysisType.split(",");
        const colorObj = resultObj?.colors?.find((obj) => obj.productCode === productCodeTitle) || {};
        const datum = {
            color: {},
            label: {},
        };

        keys.forEach((ele, i) => {
            if (i === 0) {
                datum["color"][ele] = formatColor(colorObj["common"]);
                if (ele === "mean") {
                    datum["label"][ele] = colorObj["label"];
                } else {
                    datum["label"][ele] = colorObj["common_label"];
                }
            } else if (i === 1) {
                datum["color"][ele] = formatColor(colorObj["ordinary"]);
                datum["label"][ele] = colorObj["ordinary_label"];
            }
            if (ele === "mean") {
                datum["significance_pvalue"] = resultObj?.significance_pvalue;
            }
            if (ele.includes("top")) {
                datum["top_significance"] = resultObj?.top_significance;
            }
            if (ele.includes("bottom")) {
                datum["bottom_significance"] = resultObj?.bottom_significance;
            }
        });
        return datum;
    } else {
        const datum = {};
        return datum;
    }
};

export const getTtestLabel = (result, box) => {
    if (box) {
        return result?.["common_label"];
    } else {
        return result?.["label"];
    }
};

export const getColorsAndLetterForTransposedTable = (testAnalysisType = "", productCodeTitle = "", resultObj = {}) => {
    const keys = testAnalysisType.split(",");
    const colorObj = resultObj?.colors?.find((obj) => obj.productCode === productCodeTitle) || {};
    const datum = {
        color: {},
        label: {},
    };

    keys.forEach((ele, i) => {
        if (i === 0) {
            if (resultObj?.test_name !== "z test" || resultObj?.colors?.length === 2) {
                datum["color"][ele] = formatColor(colorObj["common"]);
            }
            datum["label"][ele] = colorObj.common ? getTtestLabel(colorObj, ele === "top_per" || ele === "bottom_per") : "";
            
        } else if (i === 1) {
            if (resultObj?.test_name !== "z test" || resultObj?.colors?.length === 2) {
                datum["color"][ele] = formatColor(colorObj["ordinary"]);
            }
            datum["label"][ele] = colorObj.ordinary ? colorObj["ordinary_label"] : "";
            
        } else if (i === 2) {
            if (resultObj?.test_name !== "z test" || resultObj?.colors?.length === 2) {
                datum["color"][ele] = formatColor(colorObj["middle_color"]);
            }
            datum["label"][ele] = colorObj["middle_label"];
            
        }
    });
    return datum;
};

export const getTTestResultProductHashMap = (tTestResult) => {
    /*
    tTestResultHashmap sample format
    tTestResultHashmap = {
        "R_OO" : {
            "Above Men Sport Energy": "A", // key is product code and value is label
            "Dove Product" : "A", // key is product code and value is label
            "Old Spice Product" : "A", // key is product code and value is label
        },
        "R_OO_EaseUse" : {
            "Above Men Sport Energy": "A", // key is product code and value is label
            "Dove Product" : "A", // key is product code and value is label
            "Old Spice Product" : "A", // key is product code and value is label
        }
        ...
        ...
    }
    */

    // Iterate through the input array
    /// only for label code

    const tTestResultHashmap = {};

    tTestResult.forEach((item) => {
        if (item?.test_name !== "student's t test comparisons" && item?.test_name !== "student's t test comparisons(1-tailed)") {
            const backendVariable = item.backendVariable;

            // Initialize the entry in the output if it doesn't exist
            if (!tTestResultHashmap[backendVariable]) {
                tTestResultHashmap[backendVariable] = {};
            }

            // Iterate through colors and assign labels
            item.colors.forEach((color) => {
                tTestResultHashmap[backendVariable][color.productCode] = color?.label || "";
            });

        }        
    });
    return tTestResultHashmap;
};

export const getFragranceTTestResultProductHashMap = (tTestResult) => {
    // Iterate through the input array
    /// only for label code

    const tTestResultHashmap = {};

    tTestResult.forEach((item) => {
        const backendVariable = item.backendVariable;

        // Initialize the entry in the output if it doesn't exist
        if (!tTestResultHashmap[backendVariable]) {
            tTestResultHashmap[backendVariable] = {};
        }

        tTestResultHashmap[backendVariable]["significance_pvalue"] = item?.significance_pvalue;

        // Iterate through colors and assign labels
        item.colors.forEach((color) => {
            tTestResultHashmap[backendVariable][color.productCode] = [];
            tTestResultHashmap[backendVariable][color.productCode]["label"] = color?.label || "";
            tTestResultHashmap[backendVariable][color.productCode]["standard_error"] = color?.standard_error || "NA";
        });
    });
    return tTestResultHashmap;
};

export const getTTestFilterWarningFlag = (selectedProducts, consumerFilterStoreData) => {
    if (selectedProducts.length >= 2) {
        const selectedFilters = {};
        selectedProducts.map((eachProduct) => {
            let productCode = eachProduct.title
                .split(" ")
                .filter((ele) => ele !== "")
                .join("_");
            productCode = `${productCode}__${eachProduct.coreDataId}`;

            const selectedProductFilters = consumerFilterStoreData[productCode]?.filters || {};
            const checkedFilters = {};
            Object.keys(selectedProductFilters).forEach((filterCategory) => {
                const filterOptions = selectedProductFilters?.[filterCategory] || [];
                const checkedOptions = filterOptions.filter((option) => option.checked === true);
                if (checkedOptions.length > 0) {
                    checkedFilters[filterCategory] = checkedOptions;
                }
            });

            selectedFilters[productCode] = {
                filters: checkedFilters,
            };
        });

        const filterKeys = Object.keys(selectedFilters);
        let isEqual = true;
        for (let i = 0; i < filterKeys.length - 1; i++) {
            const currentFilter = selectedFilters[filterKeys[i]].filters;
            const nextFilter = selectedFilters[filterKeys[i + 1]].filters;
            const currentFilterKeys = Object.keys(currentFilter);
            const nextFilterKeys = Object.keys(nextFilter);
            if (currentFilterKeys.length === 0 && nextFilterKeys.length === 0) {
                isEqual = true;
                continue;
            } else if (currentFilterKeys.length !== nextFilterKeys.length || currentFilterKeys.length === 0 || nextFilterKeys.length === 0) {
                isEqual = false;
                break;
            } else {
                let flag = false;
                currentFilterKeys.every((eachFilter) => {
                    if (nextFilterKeys.includes(eachFilter)) {
                        const currentSubFilters = currentFilter[eachFilter].map((item) => item.value).sort();
                        const nextSubFilters = nextFilter[eachFilter].map((item) => item.value).sort();
                        if (currentSubFilters.length === nextSubFilters.length) {
                            flag = currentSubFilters.every((val, index) => val === nextSubFilters[index]);
                        } else {
                            flag = false;
                        }
                    } else {
                        flag = false;
                    }
                });
                isEqual = flag;
            }
        }
        return isEqual;
    } else {
        return true;
    }
};
